import { render, staticRenderFns } from "./generatePage.vue?vue&type=template&id=08c03f48&scoped=true"
import script from "./generatePage.vue?vue&type=script&lang=js"
export * from "./generatePage.vue?vue&type=script&lang=js"
import style0 from "./generatePage.vue?vue&type=style&index=0&id=08c03f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c03f48",
  null
  
)

export default component.exports